import { observer } from "mobx-react-lite";
import { useState, type FormEvent } from "react";

import { desktop } from "../../desktop.ts";
import { useStores } from "../../stores/RootStore.ts";
import { Button, Card, ErrorText, Input, Label, Muted, Page, Row, Title } from "../ui/primitives.tsx";

/** Logs in to mainions: the main controller's address and the mainions password. */
export const LoginPage = observer(function LoginPage() {
    const { connection, ui } = useStores();
    const [url, setUrl] = useState(connection.settings.url);
    const [password, setPassword] = useState("");

    function logIn(event: FormEvent) {
        event.preventDefault();
        connection.save({ ...connection.settings, url, password });
        ui.show({ name: "workers" });
    }

    return (
        <Page as="form" onSubmit={logIn}>
            <Card>
                <Title>Log in to your mainions</Title>
                {connection.status === "refused" && <ErrorText>That password didn't work. Try again.</ErrorText>}
                <Label>
                    Address
                    <Input value={url} onChange={(event) => setUrl(event.target.value)} placeholder="wss://203-0-113-7.sslip.io" required />
                </Label>
                <Muted>Your server's address, starting with wss://. You got it when you set mainions up.</Muted>
                <Label>
                    Mainions password
                    <Input value={password} onChange={(event) => setPassword(event.target.value)} type="password" required autoFocus />
                </Label>
                <Muted>The password you chose when you set mainions up. It stays on this device.</Muted>
            </Card>
            <Row>
                <Button $primary type="submit">
                    Log in
                </Button>
                {desktop && (
                    <Button type="button" onClick={() => ui.show({ name: "welcome" })}>
                        Back
                    </Button>
                )}
            </Row>
        </Page>
    );
});
